<template>
  <div>
    <v-row v-if="prop != null" class="ma-0 my-1 ml-2">
      <div class="ma-0 pa-0 section-sub-item">
        <v-icon size="6" class="pb-1" color="#193153">{{ icon }}</v-icon>
        <span v-html="prop" class="ml-1"></span>
        <sup
          class="vetalfa-pointer text--disabled pl-1"
          v-if="references && references.length"
          @click="setClickedReferences(references)"
          >{{ "[ref]" }}</sup
        >
      </div>
    </v-row>
    <slot></slot>
  </div>
</template>

<style>
.section-sub-item {
  background-color: transparent;
  width: 100%;
  font-size: 14px;
  font-weight: 0;
  color: #393a3a;
}
</style>

<script>
import { mdiCircleOutline } from "@mdi/js";
import { mapMutations } from "vuex";
export default {
  name: "SectionSubItem",
  props: {
    prop: {
      type: String,
    },
    references: {
      type: Array,
      default: null,
      required: false,
    },
  },
  methods: {
    ...mapMutations("topics", ["setClickedReferences"]),
  },
  data() {
    return {
      icon: mdiCircleOutline,
    };
  },
};
</script>